var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygamePlaySpeed3X = function SvgIconStorygamePlaySpeed3X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.895 8C4.1 6.554 5.665 5.5 7.25 5.5c1.933 0 3.3 1.5 3.3 3 0 .5-.3 3-4.3 3 1.583-.167 4.5.5 4.5 3 0 2-1.5 3-3.5 3-1.794 0-3.26-1-3.5-2.5m10.5-5.5 6 8m-6 0 6-8",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconStorygamePlaySpeed3X;